import React, { useRef, useEffect, useState } from 'react';
import QLoginRedirect from '_Components/Auth/QLoginRedirect';
import Layout from '_Layouts/Layout';
import GET_THEMATIC_SELECTION_LIST from '_Cards/ThematicsCard/ThematicsOverviewCards/graphql/getThematicSelectionList';
import GET_PROJECT_DETAILS from 'Routes/Settings/ProjectDetails/graphql/getProjectDetails';
import { useQuery, useLazyQuery } from 'react-apollo';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { selectThematicSelection } from '_Resources/Cards/Actions/selectThematicSelection';
import { setThematicSelectionList } from '_Resources/Cards/Actions/setThematicSelectionList';
import { setTemplateList } from '_Resources/Cards/Actions/setTemplateList';
import { selectTemplate } from '_Resources/Cards/Actions/selectTemplate';
import { withTranslation } from 'react-i18next';
import EXPORT_PRESENTATION_QUERY from '_Cards/LandingPageCard/graphql/exportPresentation';
import MainPageSubHeader from './_Components/SubHeader/MainPageSubHeader';
import MainPage from './MainPage';

type ThematicSelectionType = {
  createdBy: {
    firstName: string;
    lastName: string;
    email: string;
  };
  id: number | null;
  label: string;
  name: string;
  projectId: number;
  thematics: Array<{
    thematic: string;
    subThematic: string | null;
    subSubThematic: string | null;
  }>;
};
const action = props => {
  const subHeaderRef = useRef(null);

  const { data } = useQuery(GET_THEMATIC_SELECTION_LIST, {
    fetchPolicy: 'cache-and-network',
    variables: { projectId: props?.project?.id },
    skip: !props?.project?.id,
  });
  const { data: dataTemplateList } = useQuery(GET_PROJECT_DETAILS, {
    fetchPolicy: 'cache-and-network',
    variables: { id: props?.project?.id },
    skip: !props?.project?.id,
  });
  const allThematics: ThematicSelectionType = {
    createdBy: {
      firstName: 'system',
      lastName: 'system',
      email: 'support@qemotion.com',
    },
    id: null,
    label: props.t('button:All thematics'),
    name: props.t('button:All thematics'),
    projectId: props?.project?.id,
    thematics: [],
  };
  const title = 'Main page';

  const [toastMessage, setToastMessage] = useState('');

  const [exportPresentation, { data: exportPresentationData }] = useLazyQuery(EXPORT_PRESENTATION_QUERY, {
    fetchPolicy: 'cache-and-network',
    onCompleted: () => {
      setToastMessage(exportPresentationData?.exportPresentation?.message);
      setTimeout(() => {
        setToastMessage('');
      }, 3000);
    },
  });

  useEffect(() => {
    if (data) {
      const optionsList = data.getThematicSelectionList.map(selection => ({
        ...selection,
        label: selection.name,
      }));
      props.dispatchSetThematicSelectionList(optionsList);
      props.dispatchSelectThematicSelection(allThematics);
    }
    if (dataTemplateList && dataTemplateList.getProjectDetails) {
      const templateOptionsList = dataTemplateList.getProjectDetails.presentationTemplates.map(template => ({
        ...template,
        label: template.name,
      }));
      props.dispatchSetTemplateList(templateOptionsList);
      if (dataTemplateList.getProjectDetails.presentationTemplates.length > 0) {
        props.dispatchSelectTemplate(templateOptionsList[0]);
      }
      if (dataTemplateList.getProjectDetails.presentationTemplates.length === 0) {
        props.dispatchSelectTemplate({
          id: null,
          name: props.t('button:No template'),
          label: props.t('button:No template'),
          isDisabled: true,
        });
      }
    }
  }, [data, dataTemplateList, props?.project?.id]);

  const body = <MainPage subHeaderRef={subHeaderRef} toastMessage={toastMessage} />;

  const subHeader = (
    <MainPageSubHeader
      subHeaderRef={subHeaderRef}
      dispatchSetThematicSelectionList={props.dispatchSetThematicSelectionList}
      dispatchSelectThematicSelection={props.dispatchSelectThematicSelection}
      selectedThematicSelectionOption={props.selectedThematicSelectionOption}
      selectionList={props.selectionList}
      project={props.project}
      templateList={props.templateList}
      selectedTemplate={props.selectedTemplate}
      dispatchSetTemplateList={props.dispatchSetTemplateList}
      dispatchSelectTemplate={props.dispatchSelectTemplate}
      exportPresentation={exportPresentation}
    />
  );
  const tourID = 3;
  return (
    <QLoginRedirect history={props.history}>
      <Layout body={body} title={title} tourID={tourID} {...props} hideMentionsCount subHeader={subHeader} />
    </QLoginRedirect>
  );
};

const mapStateToProps = state => ({
  selectionList: get(state, ['thematicSelections', 'list']) || [],
  selectedThematicSelectionOption: get(state, ['thematicSelections', 'selectedThematicSelectionOption']),
  project: get(state, ['projects', 'currentProject']),
  templateList: get(state, ['reporting', 'templateList']),
  selectedTemplate: get(state, ['reporting', 'selectedTemplate']),
});

const mapDispatchToProps = dispatch => ({
  dispatchSetThematicSelectionList: (thematicSelectionList: Object[]) => {
    dispatch(setThematicSelectionList(thematicSelectionList));
  },
  dispatchSelectThematicSelection: thematicSelection => {
    dispatch(selectThematicSelection(thematicSelection));
  },
  dispatchSetTemplateList: templateList => {
    dispatch(setTemplateList(templateList));
  },
  dispatchSelectTemplate: template => {
    dispatch(selectTemplate(template));
  },
});

export default withTranslation('card', ['button'])(connect(mapStateToProps, mapDispatchToProps)(action));
